import Field from 'components/Field';
import styled from 'styled-components';
import tokens from 'tokens';
import * as Grid from 'components/Grid';
import { Grid as AttainGrid, theme } from '@klover/attain-design-system';
export const Label = styled.label`
  ${tokens.typography.label};
  display: block;
  margin-bottom: ${tokens.spacing.xs};
`;

type OfferListItemProps = {
  selected: boolean;
  disabled: boolean;
};

export const SubHeader = styled.h3`
  ${tokens.typography.subheaderSm};
  margin: ${tokens.spacing.lg} 0 ${tokens.spacing.sm};
  font-family: 'Calibre-Semibold';
  font-size: 18px;
`;

export const SubHeaderClean = styled(SubHeader)`
  margin-top: 0;
  font-family: 'Calibre-Semibold';
  font-size: 18px;
`;

export const Wrapper = styled(Grid.Container)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

export const SearchOffers = styled(Grid.Col)`
  display: flex;
`;

export const SearchField = styled.div`
  flex-grow: 1;
  padding-right: ${tokens.spacing.sm};
`;

export const OfferListItem = styled.li<OfferListItemProps>`
  background: ${tokens.colorPagebg};
  border: 1px solid ${tokens.colorGray40};
  border-radius: ${tokens.spacing.xs};
  box-shadow: 0 ${tokens.spacing.xs} ${tokens.spacing.xs} rgba(0, 0, 0, 0.1);
  color: ${(props) => (props.disabled ? tokens.colorGray40 : tokens.colorBody)};
  display: flex;
  justify-content: space-between;
  padding: ${tokens.spacing.sm} ${tokens.spacing.md};
  font-family: 'Calibre-Regular';
  font-size: 16px;
  & + & {
    margin-top: ${tokens.spacing.xs};
  }
`;

export const OfferListItemName = styled.div`
  flex-grow: 1;
  line-height: 40px;
`;

export const OfferListItemPercentage = styled(Field)`
  width: 64px;
`;

export const OfferList = styled.ul`
  background: ${tokens.colorGray20};
  border: 1px solid ${tokens.colorGray40};
  border-radius: ${tokens.spacing.sm};
  height: 200px;
  margin: 0;
  overflow: auto;
  padding: ${tokens.spacing.xs};
`;

export const Note = styled.p`
  ${tokens.typography.note};
  margin-bottom: ${tokens.spacing.xs};
`;

export const TestType = styled(Field)`
  width: 180;
`;
export const Placement = styled(Field)`
  width: 180;
`;

export const Percentage = styled(Field)`
  width: 50;
`;
export const Slots = styled(Field)`
  width: 50;
`;

export const CardHeader = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xxs};
  width: 100%;
`;

export const CardTitle = styled.h2`
  ${theme.typography.headingSM};
  flex-grow: 1;
`;

export const StyledBodyContainer = styled(AttainGrid)`
  span {
    ${theme.typography.headingXS};
  }
`;

export const Toggle = styled.div`
  margin: ${tokens.spacing.lg} 0;
`;

export const RadioGroup = styled.div`
  padding: ${tokens.spacing.md} 0;
`;

export const InputElementLabel = styled.div`
  font-family: 'Calibre-Semibold';
  font-size: 16px;
`;